// extracted by mini-css-extract-plugin
export default {"cls1":"StickyWorkCardHeader-cls1_SCE","cls2":"StickyWorkCardHeader-cls2_xme StickyWorkCardHeader-cls1_SCE"};